import { jwtDecode } from "jwt-decode";
import { useAuthStore } from "../store/useAuthStore";

export function revalidateAuth() {
  if (!checkTokenValidity()) {
    useAuthStore.setState((store) => ({ ...store, isAuthenticated: false }));
  }
}

export function checkTokenValidity() {
  const token = localStorage.getItem("accesstoken");
  if (!token) return false;
  const decoded = decodeAuthToken(token);
  if (!decoded) return false;
  const currentTime = Date.now() / 1000;
  return decoded.exp > currentTime + 300; // 5 min buffer
}

export function decodeAuthToken(token: string) {
  try {
    return jwtDecode<{
      xUserToken: string;
      exp: number;
      userId: string;
      role: string;
      email: string;
      clientId?: string;
    }>(token);
  } catch {
    return null;
  }
}

// USER role is view/download-only; ADMIN and SUPER_ADMIN can create/edit/delete.
export function useIsAdmin() {
  const role = useAuthStore((state) => state.role);
  return role === "ADMIN" || role === "SUPER_ADMIN";
}

// Platform console (/user) is restricted to these accounts — must match
// PLATFORM_ADMIN_EMAILS in the backend (controllers/platform.ts).
export const PLATFORM_ADMIN_EMAILS = [
  "nikhilgmudakavi@gmail.com",
  "gopal@osmoair.com",
  "support@osmoair.com",
];

export function useIsPlatformAdmin() {
  const email = useAuthStore((state) => state.email);
  return !!email && PLATFORM_ADMIN_EMAILS.includes(email.toLowerCase());
}

export function useClearCredentials() {
  const credentialKeys = ["accesstoken", "id"];
  credentialKeys.forEach((key) => {
    localStorage.removeItem(key);
  });
  useAuthStore.getState().clear();
}
